module.exports = __webpack_public_path__ + "static/media/bottomMovies.036670b0.svg";